import { SMTP_CONFIG_START, SMTP_CONFIG_DATA, SMTP_CONFIG_END, SMTP_CONFIG_SAVE, SMTP_CONFIG_TEST } from '../../slices/type';

interface InitState { data: any; loading: boolean; error: any; }
const initState: InitState = { data: null, loading: false, error: null };
interface Action { type: string; payload?: any; loading?: boolean; }

const SmtpConfig_Red = (state = initState, action: Action): InitState => {
  switch (action.type) {
    case SMTP_CONFIG_START:  return { ...state, loading: true };
    case SMTP_CONFIG_DATA:   return { ...state, data: action.payload, loading: false };
    case SMTP_CONFIG_SAVE:   return { ...state, data: action.payload, loading: false };
    case SMTP_CONFIG_TEST:   return { ...state, loading: false };
    case SMTP_CONFIG_END:    return { ...state, error: action.payload, loading: false };
    default: return state;
  }
};

export default SmtpConfig_Red;
